import React from "react";
import withProviders from "../../hooks/withProviders";
import CorporateActionPairsManagement from "../../features/corporateactionpairsmanagement";
import { FilterProvider, CorporateActionPairFilters } from "../../hooks/FilterContext";

const AssetsCorporateActionPairsManagementPage = () => <CorporateActionPairsManagement />

export default withProviders([FilterProvider, { defaultFilters: CorporateActionPairFilters }])(AssetsCorporateActionPairsManagementPage);